import { initPagePodcast } from '@/pages-podcast/init'

initPagePodcast()
